import {useEffect, useState} from "react";
import Loading from "../../component/Loading/Loading";
import {getAllOrders} from "./functions";
import {PickDateTimeWithoutContainer} from "../../component/PickDate/PickDate";
import {Link, useLocation, useSearchParams} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencil} from "@fortawesome/free-solid-svg-icons";
import FilterOrders from "./component/FilterOrders/FilterOrders";

const Orders = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [allOrders, setAllOrders] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();

    useEffect(() => {
        (async () => {
            document.title = "مدیریت سفارشات" ;
            setIsLoading(true);
            const allOrders = await getAllOrders(location.search);
            console.log(allOrders);
            setAllOrders(allOrders);
            setIsLoading(false);
        })();

    }, [searchParams]);


    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">مدیریت سفارشات</h1>
            </div>

            <FilterOrders searchParams={Object.fromEntries([...searchParams])} onSubmit={async (value) => {
                const newSearchParams = {...Object.fromEntries([...searchParams])  , ...value , page : 1 };
                setSearchParams(newSearchParams)
            }} />

            {isLoading && <Loading />}

            {!isLoading && <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className={"table text-center"}>
                                    <thead>
                                    <tr>
                                        <th width={"3%"}>#</th>
                                        <th width={"3%"}>آیدی</th>
                                        <th width={"5%"}>کد رهگیری</th>
                                        <th width={"13%"}>زمان ثبت فاکتور</th>
                                        <th width={"13%"}>زمان تحویل فاکتور</th>
                                        <th>نام مشتری</th>
                                        <th width={"5%"}>شماره تماس</th>
                                        <th width={"10%"}>مبلغ فاکتور (تومان)</th>
                                        <th width={"10%"}>مبلغ دریافت شده (تومان)</th>
                                        <th width={"10%"}>وضعیت</th>
                                        <th width={"5%"}></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        allOrders.map((order, index) => {
                                            return (
                                                <tr key={order.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{order.id}</td>
                                                    <td>{order.trackingCode}</td>
                                                    <td>{order.insertedTimestamp &&
                                                        <PickDateTimeWithoutContainer disabled={true}
                                                                                      timestamp={order.insertedTimestamp}/>}</td>
                                                    <td>
                                                        <PickDateTimeWithoutContainer disabled={true}
                                                                                      timestamp={order.deliveryTimestamp}/>
                                                    </td>
                                                    <td>{order.customer.person.firstname + " " + order.customer.person.lastname}</td>
                                                    <td>{order.customer.person.activePhonenumber}</td>
                                                    <td>{order.totalAmount.toLocaleString()}</td>
                                                    <td>{order.payedAmount.toLocaleString()}</td>
                                                    <td>
                                                        {
                                                            (order.status == "VERIFIED" && <span className={"text-success"}>تایید شده</span>) ||
                                                            (order.status == "OPEN" && <span className={"text-warning"}>باز</span>) ||
                                                            (order.status == "EXPIRED" && <span className={"text-danger"}>منقضی شده</span>)
                                                        }
                                                    </td>
                                                    <td>
                                                        <Link to={`./update/${order.id}`} type={"button"}
                                                              className={"btn btn-secondary"}>
                                                            <FontAwesomeIcon icon={faPencil}/></Link>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}


        </div>
    );
}

export default Orders;